import {Component, Input} from '@angular/core';
import {WizardType} from '../../wizard-type.enum';

@Component({
  selector: 'app-wizard-data-sharing',
  imports: [],
  standalone: true,
  templateUrl: './wizard-data-sharing.component.html'
})
export class WizardDataSharingComponent {
  @Input() wizardType: WizardType;
  @Input() description: string;

  protected readonly WizardType = WizardType;
}
